export function formatPhoneNumber(phone: string) {
    const cleaned = phone.replace(/\D/g, '');
    phone = cleaned
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2');
    
    return phone
}